import { authGuard } from '../services/guards/auth.guard';
import { permissionGuard } from '../services/guards/permission.guard';
import { PermissionValue, ResourceValue } from '../services/permissions/permissions.types';
import { TitleTranslateResolver } from '../services/translate/title-translate.resolver';
import { ListingPageService } from '../shared/components/listing-page/listing-page.service';
import { QueryParamsHandlerService } from '../shared/components/listing-page/services/query-params-handler/query-params-handler.service';
import { TranslateRegistry } from '../services/translate/translate.registry';
import { reportsModelProvider } from './app.providers';
import { PortalPath, PortalRoute, RouteItem } from './app.types';

export const reportsRoutes: PortalRoute = {
  path: PortalPath.reports,
  canMatch: [authGuard, permissionGuard],
  data: {
    hasListingLayout: true,
    routeItem: new RouteItem({
      group: TranslateRegistry.get.MAIN_MENU.SECTION.REPORTING,
      title: TranslateRegistry.get.MAIN_MENU.TITLE.REPORTS,
      icon: 'table',
      sort: 1,
      path: PortalPath.reports,
      hasRight: {
        // TODO: rename resource to REPORTS_LIST once the backend exposes it.
        resourceValue: ResourceValue.DEFAULT_REPORTS,
        targetPermissionValue: PermissionValue.VIEW
      }
    })
  },
  children: [
    {
      path: '',
      title: TitleTranslateResolver,
      data: {
        titleTranslation: TranslateRegistry.get.MAIN_MENU.TITLE.REPORTS,
        hasListingLayout: true,
        routeItem: null
      },
      loadComponent: () => import('../pages/reporting/components/reports-list/reports-list.component'),
      providers: [reportsModelProvider, ListingPageService, QueryParamsHandlerService]
    },
    {
      path: ':id',
      title: TitleTranslateResolver,
      data: {
        titleTranslation: TranslateRegistry.get.MAIN_MENU.TITLE.REPORTS,
        hasListingLayout: true,
        routeItem: new RouteItem({ title: '' })
      },
      loadComponent: () => import('../pages/reporting/components/report-view/report-view.component')
    }
  ]
};
